// TODO: Add lazy loading of images

function megaMenuImageAnimation() {
	const subMenus = document.querySelectorAll(
		'.header-menu .menu-item.menu-item-has-children .sub-menu-container'
	);
	if (subMenus.length === 0) return;

	subMenus.forEach((subMenu) => {
		const menuItems = subMenu.querySelectorAll('li.menu-item');
		let lastImage;

		menuItems.forEach((menuItem, index) => {
			const image = menuItem.querySelector('img.sub-menu-thumb');
			if (!image) return;

			// Set initial styles
			image.style.bottom = '-100%';
			image.style.zIndex = 0;

			if (index === 0) {
				image.style.bottom = 0;
				image.style.zIndex = 1;
				lastImage = image;
			}

			// Add hover effect
			const link = menuItem.querySelector('a');
			if (!link) return;

			link.addEventListener('mouseenter', () => {
				if (lastImage === image) return; // Skip if hovering same item

				// New image goes on top
				image.style.zIndex = 2;

				// Animate new image up
				gsap.fromTo(
					image,
					{ bottom: '-100%' },
					{
						bottom: 0,
						duration: 0.4,
						ease: 'power2.out',
						onComplete: () => {
							// After animation completes, send old image to back
							if (lastImage) {
								lastImage.style.zIndex = 0;
								lastImage.style.bottom = '-100%';
							}
							// Current image becomes the base layer
							image.style.zIndex = 1;
							lastImage = image;
						},
					}
				);
			});
		});
	});
}

megaMenuImageAnimation();

function megaMenuAnimation() {
	const menuItems = document.querySelectorAll(
		'.header-menu .menu-item-has-children'
	);

	function setOffset(menuItem) {
		const megaMenu = menuItem.querySelector('.sub-menu-container');
		if (!megaMenu) return;

		const megaMenuHeight = megaMenu.offsetHeight;
		megaMenu.style.setProperty(
			'--mega-menu-offset-top',
			`${-megaMenuHeight}px`
		);
		// Ensure the menu starts hidden
		megaMenu.style.top = `${-megaMenuHeight}px`;
	}

	menuItems.forEach((menuItem) => {
		const megaMenu = menuItem.querySelector('.sub-menu-container');
		if (!megaMenu) return;

		// Set offset on initial load
		setOffset(menuItem);

		// Hover animations
		menuItem.addEventListener('mouseenter', (e) => {
			e.stopPropagation();
			gsap.to(megaMenu, { top: 0 });
		});

		menuItem.addEventListener('mouseleave', () => {
			const megaMenuHeight = megaMenu.offsetHeight;
			gsap.to(megaMenu, { top: -megaMenuHeight });
		});
	});

	// Update offsets on resize
	window.addEventListener('resize', () => {
		if (window.innerWidth < 767) return;
		menuItems.forEach((menuItem) => setOffset(menuItem));
	});
}

megaMenuAnimation();
